module.exports = __webpack_public_path__ + "img/main_media_slide7.9f1fe8f2.jpg";